import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import { grey } from "@mui/material/colors";
import { OrganizationUserContext } from "contexts/Organization";
import { SubscriptionContext } from "contexts/Subscription";
import { useContext } from "react";
import { UpgradeDialogSource } from "schemas/dashboard";
import { LIGHT_GREY } from "styles/oneOffColor";

const CurrentPlanCard = () => {
  const { subscription, emailSents, setUpgradeDialogSource } =
    useContext(SubscriptionContext);
  const { currentOrg } = useContext(OrganizationUserContext);
  const isAutopilot = currentOrg?.showAutopilotPlan;
  if (subscription?.isSubscribed) {
    return <></>;
  }

  const renderChip = (text: string) => {
    return (
      <Box
        sx={{
          backgroundColor: "white",
          width: "max-content",
          px: 2,
          py: 0.5,
          border: `1px solid ${grey[300]}`,
          borderRadius: 4,
        }}
      >
        <Typography
          sx={{ color: "black", textTransform: "uppercase", fontSize: 14 }}
        >
          {text}
        </Typography>
      </Box>
    );
  };
  return (
    <Box sx={{ backgroundColor: "white", px: 1 }}>
      <Box sx={{ backgroundColor: LIGHT_GREY, p: 1, borderRadius: 4 }}>
        <Grid container justifyContent="flex-end" sx={{ mb: 4 }}>
          <Box
            sx={{
              backgroundColor: "white",
              borderRadius: 4,
              px: 2,
              py: 0.5,
              fontWeight: 600,
              width: "max-content",
            }}
          >
            You're using 1 of 10 Bento tools
          </Box>
        </Grid>

        <Box sx={{ pl: 2, pb: 3 }}>
          <Typography sx={{ fontSize: 14 }}>Your Plan: </Typography>

          <Typography variant="h2">Free</Typography>

          <Divider sx={{ borderColor: grey[300], my: 2 }} />

          {emailSents === 0 ? (
            "You have not sent any emails this month"
          ) : (
            <>
              You have sent <strong>{emailSents}</strong> email
              {emailSents === 1 ? "" : "s"} this month.
            </>
          )}
        </Box>
      </Box>

      <Box sx={{ p: 3, pb: 1, pr: 1 }}>
        <Typography variant="h5" sx={{ mb: 2 }}>
          Upgrade to unlock{" "}
        </Typography>

        <Grid container gap={1} alignItems={"center"}>
          {renderChip("✨ Automated follow-ups")}
          {renderChip("🧠 Brand Filters")}
          {renderChip("📈 Reply Score")}
          {renderChip("🔑 Exclusive Contacts & Brands")}
          {renderChip("💸 Brand Pay Data")}
          {renderChip("🎯 Campaigns")}
          {!isAutopilot && renderChip("⚡️ AI Assistant")}
          {renderChip("👀 Email Tracking")}
          {isAutopilot
            ? renderChip("🙌 Hands-free Pitching")
            : renderChip("🤝 Negotiation Helper")}
        </Grid>

        <Button
          sx={{ mt: 2, py: 1 }}
          disableElevation
          fullWidth
          variant="contained"
          onClick={() => setUpgradeDialogSource(UpgradeDialogSource.all_tools)}
        >
          Upgrade to unlock access
        </Button>
      </Box>
    </Box>
  );
};

export default CurrentPlanCard;
